const inlineEditAcceptId = 'editor.action.inlineEdit.accept';
const inlineEditRejectId = 'editor.action.inlineEdit.reject';
const inlineEditJumpToId = 'editor.action.inlineEdit.jumpTo';
const inlineEditJumpBackId = 'editor.action.inlineEdit.jumpBack';
export { inlineEditAcceptId, inlineEditJumpBackId, inlineEditJumpToId, inlineEditRejectId };
